import barba from '@barba/core'
import gsap from 'gsap'
import 'custom-event-polyfill';

export default function (routes) {


  barba.init({
    timeout: 5000,
    requestError: (trigger, action, url, response) => {
      if (action === 'click') {
        barba.force(barba.url.parse(url).path)
        thisFunctionDoesNotExistInOrderToStopScriptExecution()
      }
    },
    prevent: ({ el }) => el.classList && el.classList.contains('chocolat-image') || el.classList && el.classList.contains('no-barba'),
    transitions: [
      {
        leave(data) {
            const done = this.async()
            gsap.to(data.current.container, 0.35, {
                opacity: 0,
                y: '-30px',
                ease: 'power2.out',
                onComplete: done,
            })

        },
        enter(data) {
            const done = this.async()
            const $el = data.next.container

            data.current.container.style.display = 'none'
            window.scroll(0,0)
            gsap.set($el, { opacity: 0, y: '100px', visibility: 'visible' })
            gsap.to($el,
              0.35,
              {
                opacity: 1,
                y: 0,
                ease: 'power2.out',
                onComplete: done,
            })
        },
      },
    ],
  });

  barba.hooks.after(() => {
    routes.loadEvents()
  })
}
